// extracted by mini-css-extract-plugin
module.exports = {"container":"b13981c874--container--by8KW","label":"b13981c874--label--aOaQu","description":"b13981c874--description--W6SWR"};